import React from 'react';

const Select = ({small,label,...rest}) => {
    return (
        <div className="flex flex-col items-start w-full space-y-1">
                <label htmlFor={label} className='form-label'><span
                    className={`${rest.required ? 'after:content-["*"] after:text-red-600/70' : ''}`}> {label} </span></label>
        <select {...rest} required className="form-input">
            <option key={0} value={""}>{rest.placeholder??"Select Role"}</option>
            {rest.options?.map(item=><option key={item.name} value={item.value}>{item.name}</option>)}
        </select>
        </div>

    );
};

export default Select;